/*!
 */

;(function ( $, window, document, undefined ) {

    var pluginName = 'beOffer',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;

        Plugin.setEvents();
    };

    Plugin.prototype.setEvents = function() {
        var Plugin = this;

        // console.log(Plugin.$element.find('#companyHelper').data('company-id'));

        Plugin.$element.find('.beAdminUsers--admin-users').on('click', '.beAdminUsers-delete', function() {
            var url = $(this).data('url');
            var adminUserId = $(this).data('admin-user-id');

            $.ajax({
                url: url,
                type: 'post',
                data: 'adminUserId=' + adminUserId,
                success: function(data) {
                    if(typeof data.html !== 'undefined') {
                        Plugin.$element.find('.beAdminUsers--admin-users').html(data.html);
                    }
                }
            });
        })

        Plugin.$element.find('.js-beForm--add-gestor').on('bw.Success', function(event, data) {
            Plugin.$element.find('.beAdminUsers--admin-users').html(data.html);
        });

        Plugin.$element.find('.js-beOffer--forceInvitation').on('click', function(){
            Plugin.forceInvitation();
        });

        Plugin.$element.find('.forceInvitation--enabler').on('change', function () {
            if ($('.js-master--students').val() !== '' && $('.js-master--joboffer-status-id').val() !== ''){
                $('.js-beOffer--forceInvitation').removeClass('disabled').prop('disabled', false);
            }
            else {
                $('.js-beOffer--forceInvitation').addClass('disabled').prop('disabled',true);
            }
      });

        Plugin.$element.find('.js-beOffer-forceInvitation-alert--close').on('click', function () {
            $('.js-beOffer-forceInvitation-alert').addClass('hide');
      })
    };

    Plugin.prototype.forceInvitation = function() {
        var Plugin = this;

        var studentId = Plugin.$element.find('.js-master--students').val();
        var jobOfferStatusId = Plugin.$element.find('.js-master--joboffer-status-id').val();
        var jobOfferId = window.location.pathname.split('/');

        $.ajax({
            url:"/ofertas/" + jobOfferId[3] + "/invitations/" + studentId + "/" + jobOfferStatusId,
            type: 'post',
            success: function() {
                // Listener in beTable
                $('.js-datatable--offer-invitations').trigger('dataChanged');
                $('.js-master--students').val('').trigger('change');
                $('.js-master--joboffer-status-id').val('').trigger('change');
                $('.alert-success').removeClass('hide').delay(5000).fadeOut('slow', function() {
                    $(this).addClass('hide').css('display', 'block');
                });
            },
              error : function(data){
                $('.alert-danger').removeClass('hide').delay(5000).fadeOut('slow', function() {
                  $(this).addClass('hide').css('display', 'block');
                });
              }
        });
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );